module.exports = __webpack_public_path__ + "media/images/self_employed_active-d1ba91a4.svg";